import * as T from './loyaltyAutomatedRewardsTypes';
import type { LoyaltyAutomatedRewardsState } from './loyaltyAutomatedRewardsTypes';
import type { LoyaltyAutomatedRewardsAction } from './loyaltyAutomatedRewardsActions';
import type { Reward } from '../../../components/loyalty/data/types';

const initialState: LoyaltyAutomatedRewardsState = {
  automatedRewards: [],
  loading: false,
  error: null,
  configLoaded: false,
};

function applyToggle(rewards: Reward[], rewardId: string, update: Partial<Reward>): Reward[] {
  return rewards.map((r) => (r.reward_id === rewardId ? { ...r, ...update } : r));
}

export default function loyaltyAutomatedRewardsReducer(
  state = initialState,
  action: LoyaltyAutomatedRewardsAction,
): LoyaltyAutomatedRewardsState {
  switch (action.type) {
    case T.FETCH_AUTOMATED_REWARDS_REQUEST:
      return { ...state, loading: true, error: null };
    case T.FETCH_AUTOMATED_REWARDS_SUCCESS:
      return { ...state, loading: false, automatedRewards: action.payload, configLoaded: true };
    case T.FETCH_AUTOMATED_REWARDS_FAILURE:
      return { ...state, loading: false, error: action.payload, configLoaded: true };

    case T.CLEAR_AUTOMATED_REWARDS_ERROR:
      return { ...state, error: null };

    default:
      return state;
  }
}
